import { OrgMember } from 'src/types';

type Props = {
  handleClose: (xButtonClose?: boolean) => void;
  namedApproversEnabled: boolean;
  selectedApprover: OrgMember | null;
};

export const SentForApprovalView = ({
  handleClose,
  namedApproversEnabled,
  selectedApprover,
}: Props) => {
  return (
    <>
      <h4 className='heading-300 text-primary-dark'>Cart Sent for Approval</h4>
      <p className='text-300 text-pretty text-center text-primary-dark'>
        We've sent your cart{' '}
        {namedApproversEnabled ? (
          selectedApprover?.email ? (
            <SentToUserText selectedApproverEmail={selectedApprover.email} />
          ) : (
            'off'
          )
        ) : (
          "to the person(s) assigned as 'Approver' and 'Admin' in your organization"
        )}{' '}
        for review. You'll get a confirmation email as soon as it's been
        approved and is ready to purchase or share.
      </p>
      <button
        className='button-secondary h-12'
        onClick={() => handleClose(false)}
      >
        Got it!
      </button>
    </>
  );
};

const SentToUserText = ({
  selectedApproverEmail,
}: {
  selectedApproverEmail: string;
}) => {
  return (
    <>
      to{' '}
      <a
        href={`mailto:${selectedApproverEmail}`}
        className='font-semibold text-primary underline transition-all hover:text-primary/70'
      >
        {selectedApproverEmail}
      </a>
    </>
  );
};
